import { render, staticRenderFns } from "./FeedbackListView.vue?vue&type=template&id=7d8dd0b7&"
import script from "./FeedbackListView.vue?vue&type=script&lang=ts&"
export * from "./FeedbackListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports